import { useState } from "react";
import LiItemMobile from "./LiItemMobile";

function HamburgerMenu() {
    const [navbar, setNavbar] = useState(false);
    return (
        <div className="md:hidden w-full mx-4 flex flex-row items-center justify-between z-20">
            <button
                className="p-2 text-gray-700 rounded-md outline-none"
                onClick={() => setNavbar(!navbar)}
            >
                {navbar ? (
                    <img src="/image/icon/close.png" className="w-5" />
                ) : (
                    <img src="/image/icon/menu.png" className="w-7" />
                )}
            </button>
            <ul className=
                {`${navbar ? "translate-x-0" : "translate-x-full"}
                        text-right w-2/3 h-5/6
                        duration-1000 transition absolute top-12 right-0 
                        bg-white shadow-2xl rounded-l-2xl
                        border border-x-slate-200 
              `}>
                <div className="w-full flex flex-col mb-4">
                    <div className="bg-slate-100 rounded-tl-2xl w-full flex items-center justify-center py-4 shadow">
                        <img src="/image/Logo.png" className="w-20 p-1" />
                    </div>
                    <ul className="flex flex-col mt-2">
                        <LiItemMobile link="/#downloadApp" text="دانلود اپلیکیشن" />
                        <LiItemMobile link="/#linktoMessenger" text="ورود به نسخه وب" />
                        <LiItemMobile link="/#callwithUs" text="تماس با ما" />
                        <LiItemMobile link="/#callwithUs" text="پشتیبانی" />
                    </ul>
                </div>
            </ul>
        </div>
    )
}
export default HamburgerMenu;